/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventdetectorEventEventdetector
 */
export interface EventdetectorEventEventdetector {
    /**
     * 
     * @type {string}
     * @memberof EventdetectorEventEventdetector
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EventdetectorEventEventdetector
     */
    name?: string;
}

/**
 * Check if a given object implements the EventdetectorEventEventdetector interface.
 */
export function instanceOfEventdetectorEventEventdetector(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventdetectorEventEventdetectorFromJSON(json: any): EventdetectorEventEventdetector {
    return EventdetectorEventEventdetectorFromJSONTyped(json, false);
}

export function EventdetectorEventEventdetectorFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventdetectorEventEventdetector {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function EventdetectorEventEventdetectorToJSON(value?: EventdetectorEventEventdetector | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

